import React from "react";
import { Table, TableBody } from "@mui/material";
import { TransferTableHeaderRow, TransferTableTotalRow } from "./components/TransferTableRow";
import { yellow } from "@mui/material/colors";

const bgcolors = {
  header: yellow[300],
  totalName: yellow[200],
  totalAmount: yellow[100]
}

export default function TransferTotalTable({salesPurchaseTransferInfo}) {

  const {purchaseTransferInfo, salesTransferInfo} = salesPurchaseTransferInfo;

  const totalDebitPrice 
    = (purchaseTransferInfo ? purchaseTransferInfo.totalDebitPrice : 0)
      + (salesTransferInfo ? salesTransferInfo.totalSalesPrice : 0);

  const totalCreditPrice 
    = (purchaseTransferInfo ? purchaseTransferInfo.totalCreditPrice : 0)
      + (salesTransferInfo ? salesTransferInfo.totalSalesPrice : 0);

  return (
    <Table>
      <TableBody>
        <TransferTableHeaderRow
          name="総計"
          bgcolor={bgcolors.header}
        />
        <TransferTableTotalRow
          name="総計"
          debitAmount={totalDebitPrice}
          creditAmount={totalCreditPrice}
          nameBgcolor={bgcolors.totalName}
          amountBgcolor={bgcolors.totalAmount}
        />
      </TableBody>
    </Table>
  )
}
